import book1Cover1 from '../../assets/beforewegetolderCover.png';
import book1Cover2 from '../../assets/ebooks/theinbetweencover.png';
import ebook1Cover from '../../assets/ebooks/beforewegetolderenglishEbook.png';
import ebook2Cover from '../../assets/ebooks/theinbetweenEbook.png';

export const BOOKS = [
  {
    id: 'bwgo',
    title: 'Before We Get Older',
    author: 'Loubna Bouzenzen',
    color: '#2d346c',
    digitalCover: ebook1Cover,
    arabicDigitalCover: require('../../assets/ebooks/beforewegetolderarabicEbook.png'),
    paperFront: book1Cover1,
    paperBack: book1Cover1,
    priceDigital: 600,
    pricePaper: 1500,
    subtitle: 'The 20 years Life Lessons',
    hasArabic: true,
    paperbackComingSoon: true,
  },
  {
    id: 'inbetween',
    title: 'The In-Between',
    author: 'Loubna Bouzenzen',
    color: '#f4ebd9',
    digitalCover: ebook2Cover,
    paperFront: book1Cover2,
    paperBack: book1Cover2,
    priceDigital: 800,
    subtitle: 'A Journey to Balance and Healing',
    pricePaper: 2000,
  },
  {
    id: 'bundle',
    title: 'Bundle 🎁',
    displayTitle: 'Before We Get Older | The In-Between',
    author: 'Loubna Bouzenzen',
    color: '#dcc6e0',
    digitalCover: null,
    paperFront: null,
    paperBack: null,
    priceDigital: 1100,
    pricePaper: 2700,
    isBundle: true,
  },
];

// Bundle has no single cover of its own — it always shows both books' covers together.
export const bundleCovers = {
  digital: [ebook1Cover, ebook2Cover],
  paper: [book1Cover1, book1Cover2],
};

export const getTextColor = (bg) => (bg === '#2d346c' ? '#ffffff' : '#2d346c');